import { render, staticRenderFns } from "./AppointmentParticipantForm.vue?vue&type=template&id=5e566514&scoped=true&"
import script from "./AppointmentParticipantForm.ts?vue&type=script&lang=ts&"
export * from "./AppointmentParticipantForm.ts?vue&type=script&lang=ts&"
import style0 from "./AppointmentParticipantForm.scss?vue&type=style&index=0&id=5e566514&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e566514",
  null
  
)

export default component.exports